module.exports = __webpack_public_path__ + "img/back.26b4d325.svg";